import styled, { css } from "styled-components"
import { UiColor, uiColorToBaseColor } from "styleguide/styles/colors"

interface Props {
  type?: "short" | "full-width"
  color?: UiColor
  width?: string
}

const Hr = styled.hr<Props>`
  height: 4px;
  width: ${props => (props.width ? props.width : "32px")};
  margin: 0;
  background-color: #ee2b16;
  border: 0;
  ${props =>
    !!props.color &&
    css`
      background-color: ${uiColorToBaseColor(props.color)};
    `}
  ${props =>
    props.type === "full-width" &&
    css`
      width: 100%;
    `} 
  border-radius: 20px;
`

export default Hr
